
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import CloseIcon from "@mui/icons-material/Close";

function DomainAssignPopup({ open, onClose }) {
  return (
    <Dialog
    open={open}
    fullWidth
    disableEscapeKeyDown
    onClose={(event, reason) => {
        // block backdrop & escape close
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        onClose();
    }}
    PaperProps={{
        sx: {
        width: "650px",
        maxWidth: "90%",
        cursor: "default", 
        userSelect: "none", 
        },
    }}
    >

      {/* TITLE */}
      <DialogTitle
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          position: "relative",
        }}
      >
        New Feature Update: Domain Selection & Approval
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.600",
            cursor: "pointer",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

     <DialogContent
  dividers
  sx={{
    fontSize: "14px",
    lineHeight: 1.6,
    px: 2,
    py: 2,
  }}
>
  {/* Description */}
  <Typography sx={{ fontSize: "14px", mb: 1.5 }}>
    A new feature has been introduced to provide better control over domain
    allocation for students in each cohort.
  </Typography>

  {/* Key Highlights */}
  <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: 0.5 }}>
    Key Highlights:
  </Typography>

  <List
    dense
    sx={{
      pl: 0,
      mb: 1.5,
      "& .MuiListItem-root": {
        alignItems: "flex-start",
        py: 0.25,
      },
      "& .MuiListItemIcon-root": {
        minWidth: 14,
        mt: "10px",
        color: "text.primary",
      },
    }}
  >
    {[
      "For every cohort, you can now select the domain list applicable to your students.",
      <>Domains can be chosen only from the <b>assigned domain</b> list.</>,
      <>Navigate to <b>Internship Menu → Assigned Domains</b> to manage domains.</>,
      <>You can <b>approve or unapprove</b> domains by selecting the corresponding checkbox.</>,
      <>In the <b>Assigned Domains</b> tab, click on the <b>"ℹ️ Info"</b> icon to view detailed domain information.</>,
    ].map((text, index) => (
      <ListItem key={index}>
        <ListItemIcon>
          <FiberManualRecordIcon sx={{ fontSize: 6 }} />
        </ListItemIcon>
        <ListItemText
          primary={text}
          primaryTypographyProps={{ fontSize: "14px" }}
        />
      </ListItem>
    ))}
  </List>

  {/* Terms & Conditions */}
  <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: 0.5 }}>
    Terms & Conditions:
  </Typography>

  <Typography sx={{ fontSize: "14px",paddingLeft:"18px"}}>
    If any student is already enrolled in a domain, that domain cannot be
    unapproved.
  </Typography>
</DialogContent>

    </Dialog>
  );
}

export default DomainAssignPopup;
